import { useMatch } from '@mentimeter/ragnar-device';
import type { ButtonT } from '@mentimeter/ragnar-ui/button';
import { Button } from '@mentimeter/ragnar-ui/button';
import { useTranslations } from 'next-intl';

export function RequestUpgradeButton(buttonProps: ButtonT) {
  const isMobile = useMatch({ lessThan: 2 });
  const t = useTranslations('purchasing.request_upgrade');

  return (
    <Button {...buttonProps}>
      {isMobile ? t('mobile_label') : t('desktop_label')}
    </Button>
  );
}
